import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.replace-all.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.for-each.js";
import axios from "axios";
import { request } from "@/js/http/http_request";
import { getErrorData, handleErrorData, ERROR_DATA } from "@/js/forms.js";
import { formatPrice, getSymbolCurrency } from "@/js/currency/currencies.js";
import { bottlings, casingWines, REGIONS } from "@/js/lists.ts";
import Confirm from "@/components/modal/ConfirmationDialog.vue";
import ErrorModal from "@/components/modal/ErrorModal.vue";
import WineNaming from "@/components/products/WineNaming.vue";
import NewSupplierPriceComponent from "@/components/supplier-prices/NewSupplierPriceComponent.vue";
var defaultFormUpdateComment = {
  id: null,
  comment: null
};
export default {
  name: "WineSupplierPriceModal",
  components: {
    Confirm: Confirm,
    ErrorModal: ErrorModal,
    WineNaming: WineNaming,
    NewSupplierPriceComponent: NewSupplierPriceComponent
  },
  props: {
    loggedUserData: Object,
    wineId: Number,
    supplierId: {
      type: Number,
      default: null
    },
    isAllowToApplyPrice: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      shown: false,
      options: {
        color: "primary",
        zIndex: 2000
      },
      isLoading: false,
      wine: null,
      formSearch: {
        label: null,
        suppliers: [],
        vintages: [],
        bottlings: [],
        wineId: null
      },
      searchLabelLastUsed: null,
      searchSuppliersLastUsed: [],
      searchVintagesLastUsed: [],
      searchBottlingsLastUsed: [],
      fetchWineSupplierPricesToken: null,
      items: [],
      headers: [{
        text: "",
        value: "isMatch",
        align: "center",
        width: "80px",
        sortable: false
      }, {
        text: "Supplier",
        value: "supplier.name",
        align: "left"
      }, {
        text: "Label",
        value: "name",
        align: "left"
      }, {
        text: "Vintage",
        value: "vintage",
        align: "center"
      }, {
        text: "Bottling",
        value: "bottling",
        align: "center"
      }, {
        text: "Creation",
        value: "createdAt",
        align: "center"
      }, {
        text: "Price / btl",
        value: "price",
        align: "center",
        cellClass: "text-nowrap"
      }, {
        text: "Original data",
        value: "rawData",
        align: "center",
        sortable: false
      }, {
        text: "Action",
        value: "action",
        align: "center",
        sortable: false
      }],
      fetchWineSupplierFiltersToken: null,
      vintages: [],
      fetchSuppliersToken: null,
      suppliers: [],
      selectedWineId: null,
      isAdding: false,
      addSupplierPriceToken: null,
      updateComment: {
        form: _objectSpread({}, defaultFormUpdateComment),
        dialogShown: false,
        disabledRemove: false,
        isPending: false,
        cancellationToken: null
      },
      rawDataDialogShown: false,
      rawHeaders: [{
        text: "Column",
        value: "name",
        align: "left"
      }, {
        text: "Value",
        value: "value",
        align: "left"
      }],
      rawData: [],
      supplier: null,
      bottlings: bottlings,
      casingWines: casingWines,
      ERROR_DATA: ERROR_DATA
    };
  },
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _this2.initComponent();
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    open: function open() {
      this.shown = true;
    },
    close: function close() {
      this.shown = false;
      this.$emit("closed", this.wine);
    },
    initComponent: function initComponent() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this3.isLoading = true;
              _this3.fetchWineSupplierFilters();
              _this3.fetchSuppliers(true);
              _context2.next = 5;
              return _this3.fetchWine();
            case 5:
              _this3.formSearch.wineId = _this3.wineId;
              _this3.formSearch.label = String.removeDiacritics(_this3.wine.display_name.replace(_this3.wine.naming_data.bottling, "").replace(_this3.wine.naming_data.vintage, "").replace(/[#_,-]/g, " ").replaceAll('"', ""));
              if (_this3.supplierId) {
                _this3.formSearch.suppliers = [_this3.supplierId];
              }
              if (_this3.wine.bottling) {
                _this3.formSearch.bottlings = [_this3.wine.bottling];
              }
              if (_this3.wine.naming_data.vintage) {
                _this3.formSearch.vintages = [_this3.wine.naming_data.vintage];
              }
              _this3.items = [];
              _this3.search();
            case 12:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    fetchWine: function fetchWine() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var response;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return request("/v1/wine/".concat(_this4.wineId, "/name"), "get", null, true, "api", null);
            case 2:
              response = _context3.sent;
              if (response) {
                _this4.wine = response.data.value;
                _this4.selectedWineId = _this4.wineId;
              }
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    fetchWineSupplierFilters: function fetchWineSupplierFilters() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _this5$fetchWineSuppl;
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              (_this5$fetchWineSuppl = _this5.fetchWineSupplierFiltersToken) === null || _this5$fetchWineSuppl === void 0 || _this5$fetchWineSuppl.cancel();
              _this5.fetchWineSupplierFiltersToken = axios.CancelToken.source();
              _this = _this5;
              _context4.next = 5;
              return request("/v1/wine/supplier-price-filters", "get", null, true, "api", null, _this5.fetchWineSupplierFiltersToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to load the supplier filters.");
                  _this.$toasted.show(errorData.message, {
                    type: errorData.type
                  });
                  return;
                }
              });
            case 5:
              response = _context4.sent;
              if (response) {
                _this5.vintages = response.data.value.vintages;
              }
            case 7:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    fetchWineSupplierPrices: function fetchWineSupplierPrices() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var _this6$fetchWineSuppl;
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this6.isLoading = true;
              _this6.searchLabelLastUsed = _this6.formSearch.label;
              _this6.searchVintagesLastUsed = _this6.formSearch.vintages;
              _this6.searchBottlingsLastUsed = _this6.formSearch.bottlings;
              _this6.searchSuppliersLastUsed = _this6.formSearch.suppliers;
              (_this6$fetchWineSuppl = _this6.fetchWineSupplierPricesToken) === null || _this6$fetchWineSuppl === void 0 || _this6$fetchWineSuppl.cancel();
              _this6.fetchWineSupplierPricesToken = axios.CancelToken.source();
              _this = _this6;
              _context5.next = 10;
              return request("/v1/wine/supplier-prices", "post", _this6.formSearch, true, "api", null, _this6.fetchWineSupplierPricesToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to load the supplier prices.");
                  _this.$toasted.show(errorData.message, {
                    type: errorData.type
                  });
                  throw e;
                }
              });
            case 10:
              response = _context5.sent;
              if (response) {
                _this6.items = response.data.value.items.map(function (x) {
                  return _objectSpread(_objectSpread({}, x), {}, {
                    isMatch: !!x.wineId
                  });
                });
                _this6.$emit("fetched", _this6.items.length);
                _this6.$emit("fetchedUpdate", {
                  wineId: _this6.wineId,
                  items: _this6.items
                });
              }
            case 12:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    search: function search() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return _this7.fetchWineSupplierPrices();
            case 2:
              _this7.isLoading = false;
            case 3:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    updateWineSupplierPrice: function updateWineSupplierPrice(item) {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var data, confirmed, _this;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              data = {};
              if (item.isMatch) {
                data = {
                  wineId: _this8.wine.id_wine
                };
              }
              confirmed = true;
              if (!item.isManual) {
                _context7.next = 7;
                break;
              }
              _context7.next = 6;
              return _this8.$refs.confirm.open("To your attention", "This price was added manually. If you uncheck it, this price will be removed. Would you like to continue?", {
                color: "warning"
              });
            case 6:
              confirmed = _context7.sent;
            case 7:
              if (!confirmed) {
                _context7.next = 13;
                break;
              }
              _this = _this8;
              _context7.next = 11;
              return request("/v1/suppliers/wine-price/".concat(item.id), "put", data, true, "api", null).then(function (_) {
                if (item.isMatch) {
                  item.wineId = _this.wine.id_wine;
                } else {
                  if (item.isManual) {
                    _this.items.splice(_this.items.indexOf(item), 1);
                  } else {
                    item.wineId = null;
                  }
                }
                _this.$toasted.show("Saved", {
                  type: "success"
                });
                _this.$emit("saved");
              }).catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to save.", true);
                handleErrorData(_this, errorData);
                item.isMatch = false;
                throw e;
              });
            case 11:
              _context7.next = 14;
              break;
            case 13:
              item.isMatch = true;
            case 14:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    applySupplierPrice: function applySupplierPrice(item) {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _this9.$emit("applied", item, function () {
                _this9.close();
                _this9.$toasted.show("Supplier price applied.", {
                  type: "success"
                });
              });
            case 1:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    fetchSuppliers: function fetchSuppliers() {
      var _arguments = arguments,
        _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var _this10$fetchSupplier;
        var init, _this, response;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              init = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : false;
              (_this10$fetchSupplier = _this10.fetchSuppliersToken) === null || _this10$fetchSupplier === void 0 || _this10$fetchSupplier.cancel();
              _this10.fetchSuppliersToken = axios.CancelToken.source();
              _this = _this10;
              _context9.next = 6;
              return request("/v1/suppliers", "get", null, true, "api", null, _this10.fetchSuppliersToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.$toasted.show("Unable to load suppliers.", {
                    type: "error"
                  });
                  return;
                }
              });
            case 6:
              response = _context9.sent;
              if (response) {
                _this10.suppliers = response.data.value.map(function (supplier) {
                  return _objectSpread(_objectSpread({}, supplier), {}, {
                    display_name: "".concat(supplier.name, " (").concat(supplier.producerId ? "producer" : "supplier", ")")
                  });
                });
                if (init && _this10.supplierId) {
                  _this10.formAdd.supplierId = _this10.supplierId;
                }
              }
            case 8:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    },
    addSupplierPrice: function addSupplierPrice(formAdd) {
      var _this11 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var _this11$addSupplierPr;
        var _this;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _this11.isAdding = true;
              (_this11$addSupplierPr = _this11.addSupplierPriceToken) === null || _this11$addSupplierPr === void 0 || _this11$addSupplierPr.cancel();
              _this11.addSupplierPriceToken = axios.CancelToken.source();
              _this = _this11;
              _context10.next = 6;
              return request("/v1/suppliers/wine-price", "post", formAdd, true, "api", null, _this11.addSupplierPriceToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to add the supplier price.");
                  _this.$toasted.show(errorData.message, {
                    type: errorData.type
                  });
                  _this.isAdding = false;
                  return;
                }
              });
            case 6:
              _this11.$toasted.show("Saved", {
                type: "success"
              });
              _this11.$emit("added");
              _context10.next = 10;
              return _this11.search();
            case 10:
              _this11.$refs.newSupplierPriceComponent.cleanComment();
              _this11.isAdding = false;
            case 12:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }))();
    },
    fetchSuppliersWhenItemsUpdated: function fetchSuppliersWhenItemsUpdated(supplierId) {
      var _this12 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return _this12.fetchSuppliers();
            case 2:
              _this12.$refs.newSupplierPriceComponent.changeSupplier(supplierId);
              _this12.$refs.newSupplierPriceComponent.updateModelSelect(supplierId);
            case 4:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      }))();
    },
    showRawData: function showRawData(item) {
      this.supplier = item.supplier;
      var result = [];
      Object.entries(JSON.parse(item.rawData)).forEach(function (x) {
        result.push({
          name: x[0],
          value: x[1]
        });
      });
      this.rawData = result;
      this.rawDataDialogShown = true;
    },
    hideRawData: function hideRawData() {
      this.rawDataDialogShown = false;
    },
    selectDefaultForAdd: function selectDefaultForAdd() {
      var _this13 = this;
      var cogs = this.wine.cogs_euro_ex_vat;
      this.$refs.newSupplierPriceComponent.setCogs(cogs);
      if (this.wine.id_region != REGIONS.FRANCE.BORDEAUX.id) {
        var producerSupplier = this.suppliers.find(function (x) {
          return x.producerId === _this13.wine.producerId;
        });
        if ((producerSupplier === null || producerSupplier === void 0 ? void 0 : producerSupplier.id) > 0) {
          this.$refs.newSupplierPriceComponent.setSupplier(producerSupplier === null || producerSupplier === void 0 ? void 0 : producerSupplier.id);
        }
      }
    },
    showComment: function showComment(item) {
      this.updateComment.form.id = item.id;
      this.updateComment.form.comment = item.comment;
      this.updateComment.disabledRemove = !item.comment;
      this.updateComment.dialogShown = true;
    },
    hideComment: function hideComment() {
      this.updateComment.form = defaultFormUpdateComment;
      this.updateComment.dialogShown = false;
    },
    saveComment: function saveComment() {
      var _this14 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        var _this14$updateComment;
        var _this;
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _this14.updateComment.isPending = true;
              (_this14$updateComment = _this14.updateComment.cancellationToken) === null || _this14$updateComment === void 0 || _this14$updateComment.cancel();
              _this14.updateComment.cancellationToken = axios.CancelToken.source();
              _this = _this14;
              _context13.next = 6;
              return request("/v1/suppliers/wine-price/" + _this14.updateComment.form.id + "/comment", "put", _this14.updateComment.form, true, "api", null, _this.updateComment.cancellationToken).catch(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee12(e) {
                  var errorData;
                  return _regeneratorRuntime().wrap(function _callee12$(_context12) {
                    while (1) switch (_context12.prev = _context12.next) {
                      case 0:
                        if (!axios.isCancel(e)) {
                          _this.updateComment.isPending = false;
                          _this.updateComment.cancellationToken = null;
                          errorData = getErrorData(e, {}, "Unable to update the comment", true);
                          handleErrorData(_this, errorData);
                        }
                        throw e;
                      case 2:
                      case "end":
                        return _context12.stop();
                    }
                  }, _callee12);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 6:
              _this14.$toasted.show("Saved", {
                type: "success"
              });
              _context13.next = 9;
              return _this14.search();
            case 9:
              _this14.updateComment.isPending = false;
              _this14.updateComment.cancellationToken = null;
              _this14.hideComment();
            case 12:
            case "end":
              return _context13.stop();
          }
        }, _callee13);
      }))();
    },
    formatPrice: formatPrice,
    getSymbolCurrency: getSymbolCurrency
  }
};